import { site } from "@/config/site";
import { SEO } from "@/lib/seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

const sections = [
  {
    title: "About this website",
    body: `This website is operated by ${site.name} ("we", "us"), a painting company based in Delta, British Columbia. By using this site you accept these terms. The site provides general information about our painting services and a way to request estimates.`,
  },
  {
    title: "Estimates and quotes",
    body: "Information submitted through the estimate form is used to prepare a written estimate. Nothing on this website — including any content about pricing factors — is a quote or a binding offer. A project is only booked once scope, price and schedule are agreed in writing.",
  },
  {
    title: "Photography and imagery",
    body: "Images on this site are clearly labelled concept or illustrative images and are used to show styles and standards of finish. They are not photographs of completed North Ember Painting projects unless expressly stated, and people shown in imagery are not our employees.",
  },
  {
    title: "Accuracy of information",
    body: "We work to keep the information on this site accurate and current, but content is provided as general information only and may change without notice. Colours shown in the colour palette tool are approximations — always confirm with a physical paint sample.",
  },
  {
    title: "Acceptable use of forms",
    body: "The contact and estimate forms are for genuine enquiries about our services. Automated submissions, spam, and abusive use are prohibited; the forms use technical measures (rate limiting and spam checks) to protect them.",
  },
  {
    title: "Intellectual property",
    body: "The design, text and branding of this website belong to North Ember Painting and may not be copied or reused without permission.",
  },
  {
    title: "Limitation of liability",
    body: "To the fullest extent permitted by law, we are not liable for any loss arising from use of this website or reliance on its content. Nothing in these terms limits liability that cannot be limited by law.",
  },
  {
    title: "Governing law",
    body: "These terms are governed by the laws of British Columbia and the federal laws of Canada applicable in British Columbia.",
  },
  {
    title: "Contact",
    body: `Questions about these terms: ${site.phone} or ${site.email}.`,
  },
];

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms of Use | North Ember Painting — Delta, BC"
        description="Terms of use for the North Ember Painting website: estimates, imagery disclosures, acceptable use and governing law."
        path="/terms"
      />
      <PageHero eyebrow="Legal" title="Terms of Use" intro={`Last updated: July 2026 · ${site.name}, Delta, BC`} />
      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 sm:px-6">
          <Reveal>
            <div className="space-y-10">
              {sections.map((s, i) => (
                <div key={s.title}>
                  <h2 className="font-display text-xl font-semibold text-slate-900">
                    {i + 1}. {s.title}
                  </h2>
                  <p className="mt-3 text-base leading-relaxed text-slate-600">{s.body}</p>
                </div>
              ))}
              <div className="rounded-2xl border border-amber-200/70 bg-amber-50/60 p-6 text-sm leading-relaxed text-slate-600">
                <strong className="font-semibold text-slate-800">Note for the business owner:</strong> these terms
                were drafted as a practical starting point for a BC small business. They should be reviewed by a
                qualified legal professional before being relied upon.
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
